import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=330ee987&scoped=true&"
import script from "./photoAlbum.vue?vue&type=script&lang=js&"
export * from "./photoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=330ee987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ee987",
  null
  
)

export default component.exports